import { IconProps } from './icons-props';

function SendIcon({ className, width = 32, height = 32 }: IconProps) {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox='0 0 32 32'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M7.21335 29C5.72001 29 4.77335 28.4933 4.17335 27.8933C3.00001 26.72 2.17335 24.2267 4.81335 18.9333L5.97335 16.6267C6.12001 16.32 6.12001 15.68 5.97335 15.3733L4.81335 13.0667C2.16001 7.77333 3.00001 5.26667 4.17335 4.10667C5.33335 2.93333 7.84001 2.09333 13.12 4.74667L24.5333 10.4533C27.3733 11.8667 28.9333 13.84 28.9333 16C28.9333 18.16 27.3733 20.1333 24.5467 21.5467L13.1333 27.2533C10.5467 28.5467 8.62668 29 7.21335 29ZM7.21335 5C6.49335 5 5.93335 5.17333 5.58668 5.52C4.61335 6.48 5.00001 8.97333 6.60001 12.16L7.76001 14.48C8.18668 15.3467 8.18668 16.6533 7.76001 17.52L6.60001 19.8267C5.00001 23.0267 4.61335 25.5067 5.58668 26.4667C6.54668 27.44 9.04001 27.0533 12.24 25.4533L23.6533 19.7467C25.7467 18.7067 26.9333 17.3333 26.9333 15.9867C26.9333 14.64 25.7333 13.2667 23.64 12.2267L12.2267 6.53333C10.2 5.52 8.45335 5 7.21335 5Z'
                fill='currentColor'
            />
            <path
                d='M14.4534 17H7.25342C6.70675 17 6.25342 16.5467 6.25342 16C6.25342 15.4533 6.70675 15 7.25342 15H14.4534C15.0001 15 15.4534 15.4533 15.4534 16C15.4534 16.5467 15.0001 17 14.4534 17Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default SendIcon;

